import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
//import FramePlayer from "image-sequence-player";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import ImageListItemBar from "@material-ui/core/ImageListItemBar";
import ViewListIcon from "@material-ui/icons/ViewList";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import ViewQuiltIcon from "@material-ui/icons/ViewQuilt";

import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import { withStyles } from "@material-ui/core/styles";
import {
  fetchPtmGpsapirtSearch,
  fetchVideoData,
  fetchVideoDataContract,
  fetchShipnamecallsign
} from "../../api/portal";

import { pushVideoData } from "../../actions/portal";
import { pushLoader } from "../../actions/main";
import image1 from "../../assets/img/1.jpg";
import image2 from "../../assets/img/2.jpg";
import image3 from "../../assets/img/3.jpg";
import image4 from "../../assets/img/4.jpg";
import image5 from "../../assets/img/5.jpg";
import image6 from "../../assets/img/5.jpg";
import map from "../../assets/img/map1.PNG";
import Video from "./video";
import CCTVReport from "./cctvReport";
import moment from "moment";
import _ from "lodash";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "28px",
    fontWeight: 500,
    color: "#fffff"
  },
  title1: {
    flex: 1,
    fontSize: "28px",
    fontWeight: 500,
    paddingLeft: "10px"
  },
  title2: {
    textAlign: "center",
    flex: 1,
    fontSize: "18px",
    fontWeight: 500,
    paddingLeft: "10px"
  },
  contentInfo: {
    flexGrow: 1,
    backgroundColor: "#181818",
    padding: theme.spacing(2),
    height: "100%",
    width: "100%"
  },
  content: {
    flexGrow: 1,
    backgroundColor: "#181818",
    padding: theme.spacing(2),
    height: "100%",
    width: "100%"
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  toogleButton: {
    marginTop: theme.spacing(2)
  },
  paper: {
    display: "flex",
    border: `1px solid ${theme.palette.divider}`,
    flexWrap: "wrap",
    backgroundColor: "#202020",
    width: "100%"
  },
  paper2: {
    display: "flex",
    border: `1px solid #010101`,
    flexWrap: "wrap",
    backgroundColor: "#EEEEEE",
    paddding: 10
  },
  paper3: {
    display: "flex",
    border: `1px solid ${theme.palette.divider}`,
    flexWrap: "wrap",
    backgroundColor: "#fffff",
    width: "100%",
    paddingBottom: "10px",
    paddingTop: "10px"
  },
  divider: {
    margin: theme.spacing(1, 0.5)
  },
  container: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row"
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 300,
    padding: 5,
    backgroundColor: "white"
  },
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: "#181818"
  },
  imageList: {
    width: "100%",
    height: 650,
    // Promote the list into its own layer in Chrome. This cost memory, but helps keep FPS high.
    transform: "translateZ(0)"
  },
  titleBar: {
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " +
      "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)"
  }
});

const StyledToggleButtonGroup = withStyles(theme => ({
  grouped: {
    margin: theme.spacing(0.5),
    border: "none",
    "&:not(:first-child)": {
      borderRadius: theme.shape.borderRadius
    },
    "&:first-child": {
      borderRadius: theme.shape.borderRadius
    }
  }
}))(ToggleButtonGroup);

class Cctv extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      title: "",
      dataVessel: [],
      dataVideo: [],
      kamera: "All Cameras",
      sort: "Name",
      layout: "list",
      callsign: "POYT",
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DDTHH:mm"),
      endDate: moment().format("YYYY-MM-DDTHH:mm"),
      itemData: [],
      loader: null,
      cctvReport: [],
      cctvToken: ""
    };
  }

  UNSAFE_componentWillMount() {
    fetchShipnamecallsign()
      .then(response => {
        this.setState({ dataVessel: response.data.results });
      })
      .catch(error => {
        console.log(error);
        //this.props.history.push("/pages/login#logout");
      });

    fetchVideoData(
      this.state.startDate.replace("T", " "),
      this.state.endDate.replace("T", " "),
      this.state.callsign,
      this.state.cctvToken
    )
      .then(response => {
        if (response != null) {
          if (response.data.error == "callsign not found!") {
            fetchVideoDataContract(
              this.state.startDate.replace("T", " "),
              this.state.endDate.replace("T", " "),
              this.state.callsign,
              this.state.cctvToken
            )
              .then(response => {
                if (response != null) {
                  if (response.data.error == "callsign not found!") {
                    this.setState({ dataVideo: [] });
                    this.props.pushVideoData([]);
                  } else {
                    this.setState({ dataVideo: response.data.data });
                    this.props.pushVideoData(this.state.dataVideo);
                  }
                  // get per channel
                  let datach = response.data.data;
                  let ch1 = "";
                  let ch2 = "";
                  let ch3 = "";
                  let ch4 = "";
                  let ch5 = "";
                  let ch6 = "";

                  datach.map(e => {
                    let gmbr = e.split("/");
                    let channel = gmbr[6].split("_");
                    if (channel[0] == "001") {
                      ch1 = e;
                    }
                    if (channel[0] == "002") {
                      ch2 = e;
                    }
                    if (channel[0] == "003") {
                      ch3 = e;
                    }
                    if (channel[0] == "004") {
                      ch4 = e;
                    }
                    if (channel[0] == "005") {
                      ch5 = e;
                    }
                    if (channel[0] == "006") {
                      ch6 = e;
                    }
                  });

                  let itemData = [
                    {
                      img: ch1,
                      title: "AJG",
                      featured: false
                    },
                    {
                      img: ch2,
                      title: "BRT",
                      featured: false
                    },
                    {
                      img: ch3,
                      title: "CCR",
                      featured: false
                    },
                    {
                      img: ch4,
                      title: "ECR",
                      featured: false
                    },
                    {
                      img: ch5,
                      title: "WKN",
                      featured: true
                    },
                    {
                      img: ch6,
                      title: "WKR",
                      featured: true
                    }
                  ];

                  this.setState({ itemData: itemData });

                  // end get per channel
                }
              })
              .catch(error => {
                this.setState({ dataVideo: [] });
                console.log(error);
                //this.props.history.push("/pages/login#logout");
              });
          } else {
            this.setState({ dataVideo: response.data.data });
            this.props.pushVideoData(this.state.dataVideo);
          }

          // this.setState({ dataVideo: response.data.data });
          // this.props.pushVideoData(this.state.dataVideo);
          // console.log(this.dataVideo, "vidd");

          // get per channel
          let datach = response.data.data;
          let ch1 = "";
          let ch2 = "";
          let ch3 = "";
          let ch4 = "";
          let ch5 = "";
          let ch6 = "";

          datach.map(e => {
            let gmbr = e.split("/");
            let channel = gmbr[6].split("_");
            if (channel[0] == "001") {
              ch1 = e;
            }
            if (channel[0] == "002") {
              ch2 = e;
            }
            if (channel[0] == "003") {
              ch3 = e;
            }
            if (channel[0] == "004") {
              ch4 = e;
            }
            if (channel[0] == "005") {
              ch5 = e;
            }
            if (channel[0] == "006") {
              ch6 = e;
            }
          });

          let itemData = [
            {
              img: ch1,
              title: "AJG",
              featured: false
            },
            {
              img: ch2,
              title: "BRT",
              featured: false
            },
            {
              img: ch3,
              title: "CCR",
              featured: false
            },
            {
              img: ch4,
              title: "ECR",
              featured: false
            },
            {
              img: ch5,
              title: "WKN",
              featured: true
            },
            {
              img: ch6,
              title: "WKR",
              featured: true
            }
          ];

          this.setState({ itemData: itemData });

          // end get per channel
        }
      })
      .catch(error => {
        this.setState({ dataVideo: [] });
        console.log(error);
        //this.props.history.push("/pages/login#logout");
      });
  }

  getDataVessel(search) {
    fetchPtmGpsapirtSearch(search)
      .then(response => {
        if (response != null) {
          this.setState({ dataVessel: response.data.results });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        //this.props.history.push("/pages/login#logout");
      });
  }

  handleChangeKamera = e => {
    this.setState({ kamera: e.target.value });
  };

  handleChangeSort = e => {
    this.setState({ sort: e.target.value });
  };

  handleLayout = e => {
    this.setState({ layout: e.target.value });
  };

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };

  handleShow = () => {
    let start = new Date(this.state.startDate);
    let end = new Date(this.state.endDate);

    let timeStart = moment(start).format("YYYY-MM-DD HH:mm");
    let timeEnd = moment(end).format("YYYY-MM-DD HH:mm");

    fetchVideoData(
      timeStart,
      timeEnd,
      this.state.callsign,
      this.state.cctvToken
    )
      .then(response => {
        this.setState({ itemData: [] });

        if (response != null) {
          if (response.data.error == "callsign not found!") {
            fetchVideoDataContract(
              this.state.startDate.replace("T", " "),
              this.state.endDate.replace("T", " "),
              this.state.callsign,
              this.state.cctvToken
            )
              .then(response => {
                if (response != null) {
                  if (response.data.error == "callsign not found!") {
                    this.setState({ dataVideo: [] });
                    this.props.pushVideoData([]);
                  } else {
                    this.setState({ dataVideo: response.data.data });
                    this.props.pushVideoData(this.state.dataVideo);
                  }
                  // get per channel
                  let datach = response.data.data;
                  let ch1 = "";
                  let ch2 = "";
                  let ch3 = "";
                  let ch4 = "";
                  let ch5 = "";
                  let ch6 = "";

                  datach.map(e => {
                    let gmbr = e.split("/");
                    let channel = gmbr[6].split("_");
                    if (channel[0] == "001") {
                      ch1 = e;
                    }
                    if (channel[0] == "002") {
                      ch2 = e;
                    }
                    if (channel[0] == "003") {
                      ch3 = e;
                    }
                    if (channel[0] == "004") {
                      ch4 = e;
                    }
                    if (channel[0] == "005") {
                      ch5 = e;
                    }
                    if (channel[0] == "006") {
                      ch6 = e;
                    }
                  });

                  const itemData = [
                    {
                      img: ch1,
                      title: "AJG",
                      featured: false
                    },
                    {
                      img: ch2,
                      title: "BRT",
                      featured: false
                    },
                    {
                      img: ch3,
                      title: "CCR",
                      featured: false
                    },
                    {
                      img: ch4,
                      title: "ECR",
                      featured: false
                    },
                    {
                      img: ch5,
                      title: "WKN",
                      featured: true
                    },
                    {
                      img: ch6,
                      title: "WKR",
                      featured: true
                    }
                  ];

                  this.setState({ itemData: itemData });

                  // end get per channel
                }
              })
              .catch(error => {
                this.setState({ dataVideo: [] });
                console.log(error);
                //this.props.history.push("/pages/login#logout");
              });
          } else {
            this.setState({ dataVideo: response.data.data });
            this.props.pushVideoData(this.state.dataVideo);
          }

          // get per channel
          let datach = response.data.data;
          let ch1 = "";
          let ch2 = "";
          let ch3 = "";
          let ch4 = "";
          let ch5 = "";
          let ch6 = "";

          datach.map(e => {
            let gmbr = e.split("/");
            let channel = gmbr[6].split("_");
            if (channel[0] == "001") {
              ch1 = e;
            }
            if (channel[0] == "002") {
              ch2 = e;
            }
            if (channel[0] == "003") {
              ch3 = e;
            }
            if (channel[0] == "004") {
              ch4 = e;
            }
            if (channel[0] == "005") {
              ch5 = e;
            }
            if (channel[0] == "006") {
              ch6 = e;
            }
          });

          const itemData = [
            {
              img: ch1,
              title: "AJG",
              featured: false
            },
            {
              img: ch2,
              title: "BRT",
              featured: false
            },
            {
              img: ch3,
              title: "CCR",
              featured: false
            },
            {
              img: ch4,
              title: "ECR",
              featured: false
            },
            {
              img: ch5,
              title: "WKN",
              featured: true
            },
            {
              img: ch6,
              title: "WKR",
              featured: true
            }
          ];

          this.setState({ itemData: itemData });

          // end get per channel
        }
      })
      .catch(error => {
        this.setState({ dataVideo: [] });
        console.log(error);
        //this.props.history.push("/pages/login#logout");
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <GridContainer>
        <GridItem xs={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>
              <font>{this.state.title}</font>
            </Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            <Paper elevation={0} className={classes.paper3}>
              <Grid item xs={12} md={4}>
                <div style={{ paddingLeft: 30 }}>
                  <Autocomplete
                    inputValue={this.state.search}
                    onInputChange={(event, newInputValue) => {
                      this.setState({ search: newInputValue });
                      // this.getDataVessel(newInputValue);

                      let callsignnya = newInputValue.split(" (");
                      if (callsignnya.length > 1) {
                        this.setState({
                          title: newInputValue,
                          callsign: callsignnya[1].slice(0, -1)
                        });
                      }
                    }}
                    id="controllable-states-demo"
                    options={this.state.dataVessel}
                    getOptionLabel={option =>
                      option.shipname + " (" + option.call_sign + ")"
                    }
                    //style={{ width: "100%", backgroundColor: "white" }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Search"
                        //variant="filled"
                        style={{ width: "100%", paddingBottom: 1 }}
                      />
                    )}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div style={{ paddingRight: 30 }}>
                  <Grid item>
                    <form className={classes.container} noValidate>
                      <Select
                        value={this.state.kamera}
                        onChange={this.handleChangeKamera}
                        displayEmpty
                        style={{
                          left: "14px",
                          bottom: "10px"
                        }}
                        className={classes.selectEmpty}
                      >
                        <MenuItem value="All Cameras">All Cameras</MenuItem>
                        <MenuItem value="Kamera Depan 1">
                          Kamera Depan 1
                        </MenuItem>
                        <MenuItem value="Kamera Samping Kiri 1">
                          Kamera Samping Kiri 1
                        </MenuItem>
                        <MenuItem value="Kamera Samping Kanan 1">
                          Kamera Samping Kanan 1
                        </MenuItem>
                      </Select>
                      <FormControl
                        size="small"
                        style={{
                          paddingBottom: 6,
                          paddingLeft: 15,
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <TextField
                          size="small"
                          id="datetime-local"
                          label="Start Date"
                          type="datetime-local"
                          className={classes.textField}
                          defaultValue={this.state.startDate}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            value: this.state.startDate,
                            onChange: this.handleStartDate
                          }}
                        />
                        <TextField
                          size="small"
                          id="datetime-local"
                          label="End Date"
                          type="datetime-local"
                          className={classes.textField}
                          defaultValue={this.state.endDate}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            value: this.state.endDate,
                            onChange: this.handleEndDate
                          }}
                        />
                      </FormControl>
                      <FormControl
                        size="small"
                        style={{
                          paddingBottom: 6,
                          display: "flex"
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="behance"
                          onClick={this.handleShow}
                        >
                          Show
                        </Button>
                      </FormControl>
                    </form>
                  </Grid>
                </div>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} className={classes.paper}>
            <Grid container justify="center" spacing={2}>
              <Grid item xs={12} md={7}>
                <br />
                <Grid item xs={12}>
                  <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                    <Video />
                    <CustomLinearProgress
                      variant="determinate"
                      color="gray"
                      value={0}
                      style={{ width: "100%", display: "inline-block" }}
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12} md={5}>
                <div style={{ paddingRight: 30 }}>
                  <br />
                  <Grid item xs>
                    <div className={classes.root}>
                      <ImageList
                        rowHeight={200}
                        gap={2}
                        className={classes.imageList}
                      >
                        {this.state.itemData.map(item => (
                          <ImageListItem key={item.img} cols={1} rows={1}>
                            <img src={item.img} alt={item.title} />
                            <ImageListItemBar
                              title={item.title}
                              position="top"
                              className={classes.titleBar}
                            />
                          </ImageListItem>
                        ))}
                      </ImageList>
                    </div>
                  </Grid>
                  <CustomLinearProgress
                    variant="determinate"
                    color="gray"
                    value={0}
                    style={{ width: "100%", display: "inline-block" }}
                  />
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </GridContainer>
    );
  }
}

Cctv.propTypes = {
  pushVideoData: PropTypes.array
};

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    basemap: state.basemap,
    sourceAis: state.sourceAis,
    cctvToken: state.cctvToken
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      pushVideoData,
      pushLoader
    }
  )(withStyles(styles)(Cctv))
);
